// import {
//     useLocation,
//     useNavigate,
//     useParams
// } from "react-router-dom";

// function withRouter(Component : any) {
//     function ComponentWithRouterProp(props : any) {
//         let location = useLocation();
//         let navigate = useNavigate();
//         let params = useParams();
//         return (
//             <Component
//                 {...props}
//                 router={{ location, navigate, params }}
//             />
//         );
//     }

//     return ComponentWithRouterProp;
// }

// export default withRouter;

// import { Location, NavigateFunction, Params } from "react-router-dom";
// import React from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";

// export interface WithRouterProps {
//     router: {
//         location: Location;
//         navigate: NavigateFunction;
//         params: Readonly<Params<string>>;
//     };
// }

// function withRouter<T>(Component: React.ComponentType<T & WithRouterProps>) {
//     return (props: Omit<T, keyof WithRouterProps>) => {
//         let location = useLocation();
//         let navigate = useNavigate();
//         let params = useParams();

//         return <Component {...(props as T)} router={{ location, navigate, params }} />;
//     };
// }

// export default withRouter;

import { Location, NavigateFunction, Params } from "react-router-dom";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export interface WithRouterProps {
    router: {
        location: Location;
        navigate: NavigateFunction;
        params: Readonly<Params<string>>;
        queryParams: URLSearchParams;
    };
}

function withRouter<T>(Component: React.ComponentType<T & WithRouterProps>) {
    return (props: Omit<T, keyof WithRouterProps>) => {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let queryParams = new URLSearchParams(location.search); // Leer los parámetros del query string

        return (
            <Component
                {...(props as T)}
                router={{ location, navigate, params, queryParams }}
            />
        );
    };
}

export default withRouter;
